import { render, staticRenderFns } from "./Uniforme.vue?vue&type=template&id=18ff9ff0"
import script from "./Uniforme.vue?vue&type=script&lang=js"
export * from "./Uniforme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports